export const TEXT_AREA_ROWS = 5
export const TEXT_AREA_ROWS_MIN = 2

export const THEME_HUES = [
  '33',
  '44',
  '55',
  '66',
  '77',
  '88',
  '99',
  'aa',
  'bb',
  'cc',
  'dd',
  'ee',
  'ff'
]
export const THEME_HUES_SKIP_VALUE = 6 // 13 | 7 | 1 | 8 | 2 | 9 | 3 | 10 | 4 | 11 | 5 | 12 | 6 | 0

export const FEEDBACK_RATINGS = [5, 4, 3, 2, 1]

export const SUBMIT_OPTIONS = [
  { name: 'user', icon: 'person' },
  { name: 'visitor', icon: 'badge' },
  { name: 'anonymous', icon: 'eyeglasses_2' }
]
